import { render, staticRenderFns } from "./SocialAssets.vue?vue&type=template&id=86346c8c&"
import script from "./SocialAssets.vue?vue&type=script&lang=js&"
export * from "./SocialAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports